<p>
  <mat-spinner></mat-spinner>
  <small>
    Livetrack<br>
    Please wait up to 60s<br>
    <!-- {{this.dialogText}} -->
  </small>
</p>
